











































































































































































































    import { Component, Vue, Inject} from 'vue-property-decorator';
    import iView from 'iview';
    import Ajax from '../../../../lib/ajax';
    import AbpBase from '../../../../lib/abpbase';
    import Appconst from '../../../../lib/appconst';
    import DownloadList from "../../../../components/tools/downloadList.vue";
    import QuickTable from "../../../../components/table/table.vue";
	@Component({
		name:'trainManage',
		components: {
			DownloadList,
			QuickTable
		}
	})
    export default class EduTrainManage extends AbpBase  {
        initData:any ={
        	showModal: false,
        	showDetailModal: false,
            searchData: {
            	TrainContent: ''
            },
            fileUrl: Appconst.fileUrl,
            uploadFilePreview: [],
            details: {},
            detailForm: {},
            trainTypes: [],
            columns: [
				{
					title: '序号',
					width: 60,
					align: 'center',
					render: (h:any, params:any) => {
						return h('span', params.index + 1);
					}
				},
				{
					title: '培训类别',
					width: 116,
					key: 'trainTypeDesc'
				},
				{
					title: '培训时间',
					width: 106,
					key: 'trainDt',
					render: (h:any, params:any) => {
						return h('span', this.formatDate(params.row.trainDt));
					}
				},
				{
					title: '培训地点',
					key: 'trainAddress'
				},
				{
					title: '培训内容（题目）',
					key: 'trainContent'
				},
				{
					title: '主持人',
					key: 'host'
				},
				{
					title: '参会人',
					key: 'attendee'
				},
				{
					title: '参会人数',
					key: 'meetingUserCount'
				},
				{
					title: '培训专家',
					key: 'trainExpert'
				},
				{
					title: '操作',
					width: 178,
					render: (h:any, params:any) => {
						return h('div', [
							h('Button', {
								props: {
									type: 'primary',
									size: 'small'
								},
								on: {
									click: () => {
										this.handleLookDetail(params.row.id);
									}
								}
							}, '查看'),
							h('Button', {
								props: {
									type: 'success',
									size: 'small'
								},
								style: {
									marginLeft: '10px'
								},
								on: {
									click: () => {
										this.handleEditForm(params.row.id);
									}
								}
							}, '编辑'),
							/*h('Button', {
								props: {
									type: 'error',
									size: 'small'
								},
								style: {
									marginLeft: '10px'
								},
								on: {
									click: () => {
										this.handleDelete(params.row.id);
									}
								}
							}, '删除')*/
						])
					}
				}
			],
            previewUrl: '',
	        previewVisible: false
        }
        formLoading:any = false
        formData:any = {
        	id: '',
            trainDt: '',
			trainAddress: '',
			trainType: 1,
			trainContent: '',
			host: '',
			trainExpert: '',
			attendee: '',
			meetingSummary: '',
			meetingImages: [],
			meetingAttachs: []
        }
        ruleValidate:any = {
        	trainDt: [
                { required: true, type: 'date', message: '请选择培训时间', trigger: 'blur' }
            ],
            trainAddress: [
                { required: true, message: '请填写培训地点', trigger: 'blur' }
            ],
            trainType: [
                { required: true, type: 'number', message: '请选择培训类型', trigger: 'change' }
            ],
            trainContent: [
                { required: true, message: '请填写培训内容（题目）', trigger: 'blur' }
            ],
            host: [
                { required: true, message: '请填写主持人', trigger: 'blur' }
            ],
            attendee: [
                { required: true, message: '请填写参会人', trigger: 'blur' }
            ],
            meetingSummary: [
                { required: true, message: '请填写会议纪要', trigger: 'blur' }
            ],
            meetingImages: [
                { required: true, type: 'array', message: '请上传相关会议照片' }
            ],
            meetingAttachs: [
                { required: true, type: 'array', message: '请上传相关培训材料与会议签到表' }
            ]
        }
        // 初始化
		init() {
			// 获取培训类型
	    	this.$store.dispatch('dictionary/GetTrainTypes').then(() => {
	    		this.initData.trainTypes = this.$store.state.dictionary.trainTypes;
	    	})
		}
        GetData() {
        	(this as any).$refs.table.GetData();
        }
        //照片预览      
	    handleView (url:any) {
	        this.initData.previewUrl = this.initData.fileUrl + url;
	        this.initData.previewVisible = true;
	    }
	    handleSuccess (res:any, file:any) {
            let url:any = res.result;
            let arr:any = [];
            this.initData.uploadFilePreview.forEach((item:any) => {
            	if(item.name == file.name) {
            		url = item.url;
            	}else{
            		arr.push(item);
            	}
            })
            this.initData.uploadFilePreview = arr;
	    	this.formData.meetingImages.push({result: res.result, url: url});
	    }
	    handleFormatError (file:any) {
	        this.$Notice.warning({
	            title: '图片格式错误',
	            desc: '图片 ' + file.name + ' 格式错误, 请选择jpg或者png格式的图片'
	        });
	    }
	    handleMaxSize (file:any) {
	        this.$Notice.warning({
	            title: '图片大小错误',
	            desc: '图片 ' + file.name + ' 超过2M限制'
	        });
	    }
	    handleBeforeUpload (obj:any) {
			if(!this.formData.meetingImages) return;
	        const check = this.formData.meetingImages.length < 5;
	        if (!check) {
	            this.$Notice.warning({
	                title: '上传图片数量需小于五张'
	            });
	        }
            if(check) {
            	if((window as any).createObjectURL != undefined) {
            		obj.url = (window as any).createObjectURL(obj);
            	}else if((window as any).URL != undefined) {
            		obj.url = (window as any).URL.createObjectURL(obj);
            	}else if((window as any).webkitUrl != undefined){
            		obj.url = (window as any).webkitUrl.createObjectURL(obj);
            	}
            	this.initData.uploadFilePreview.push({name: obj.name, url: obj.url});
            }
	        return check;
	    }
	    // 上传材料
	    handleUploadFileSuccess(res:any, file:any) {
	    	
	    }
	    formatDate(d:any) {
	    	if(!d) return '';
	    	if(typeof d == 'string') {
	    		d = new Date(d);
	    	}
	    	return d.getFullYear() +'-'+ (d.getMonth() + 1) +'-'+ d.getDate();
	    }
	    // 新增
	    async handleSubmit() {
	    	this.formData.meetingAttachs = (this as any).$refs.uploadFile.fileList;
            (this.$refs.form as any).validate(async (valid:boolean)=>{
                if(valid){
                	let params:any = {
                		trainDt: this.formatDate(this.formData.trainDt),
						trainAddress: this.formData.trainAddress,
						trainType: this.formData.trainType,
						trainContent: this.formData.trainContent,
						host: this.formData.host,
						trainExpert: this.formData.trainExpert,
						attendee: this.formData.attendee,
						meetingSummary: this.formData.meetingSummary,
						meetingImages: [],
						meetingAttachs: [],
						meetingUserCount:this.formData.meetingUserCount
                	}
                	
                	// 格式化材料文件
	    			this.formData.meetingAttachs.forEach((res:any) => {
	    				if(res.response && res.response.result) {
							params.meetingAttachs.push(res.response.result);
						}
	    			})
	    			this.formData.meetingImages.forEach((item:any) => {
						if(item.result) {
	  						params.meetingImages.push(item.result);
	  					}
					})
	    			
	    			this.formLoading = true;
	    			// 编辑
	    			if(this.formData.id) {
	    				params.id = this.formData.id;
	    				await Ajax.put('/api/services/app/EducationTrain/UpdateAsync', params).then((res:any)=>{
			                this.$Message.success('编辑成功!');
	                    	this.initData.showModal = false;
        					this.GetData();
			                this.formData.id = '';
			                this.initData.details[params.id] = undefined;
			            }).catch(() => {
			            	this.formLoading = false;
			            })
	    			}else{
	    				// 添加
	    				await Ajax.post('/api/services/app/EducationTrain/CreateAsync', params).then((res:any)=>{
			                this.$Message.success('提交成功!');
			                this.initData.showModal = false;
        					this.GetData();
			            }).catch(() => {
			            	this.formLoading = false;
			            })
	    			}
                }
            })
	    }
	    handleSubmitSuccess(flog:any) {
	    	if(!flog) {
		    	this.formLoading = false;
	            this.initData.showModal = false;
	            (this as any).$refs.form.resetFields();
	            this.$set(this.formData, 'meetingAttachs', []);
	            this.$set(this.formData, 'meetingImages', []);
           	}
		}
		//删除附件
		async DeleteFile(res:any) {
			if(!!res.response){
				await Ajax.post('/api/File/DeleteTempFile?filename='+res.response.result);
				// this.formData.meetingAttachs.splice(this.formData.meetingAttachs.indexOf(res.response.result), 1);
			}else{
				await Ajax.delete('/api/services/app/EducationTrain/DeleteFileAsync?Id='+res.id);
			}
		}
		//删除照片
	    async handleDetailFile(file:any, fileList:any) {
	    	this.$Modal.confirm({
	            title:　'删除',
	            content: '确定删除吗？',
	            okText: '确定',
	            cancelText: '取消',
	            onOk: async ()=>{
	            	if(file.deletetype == 'image') {
	            		this.formData.meetingImages.splice(file.index, 1);
	            	}
	            	if(!file.id) return;
			    	await Ajax.delete('/api/services/app/EducationTrain/DeleteFileAsync', {params: {id: file.id}}).then((res:any)=>{
			    		this.$Message.success('删除成功!');
			       })
	            }
	        })
	    }
	    // 删除
	    handleDelete(id:any) {
	    	this.$Modal.confirm({
	            title: '操作确认',
	            content: '是否确认删除此教育培训记录？',
	            onOk: () => {
	                /*Ajax.delete('', {params: {Id: id}}).then((res:any)=>{
		                this.$Message.success('删除成功!');
	                	this.init();
		            })*/
	            }
	        });
	    }
	    handleEditForm(id:any) {
	    	this.handleGetDetail(id).then((res:any) => {
	    		this.formData.id = res.id;
	    		for(let k in this.formData) {
	    			if(k == 'meetingImages') {
	    				this.formData.meetingImages = res.images.map((item:any) => {
	    					return {
	    						id: item.id,
	    						url: item.url
	    					};
	    				});
	    			}else if(k == 'meetingAttachs') {
	    				this.formData.meetingAttachs = res.attachs.map((item:any) => {
	    					return {
	    						id: item.id,
	    						name: item.attachName,
	    						url: item.url
	    					};
	    				});
	    			}else{
	    				this.formData[k] = res[k];
	    			}
	    		}
	    		this.initData.showModal = true;
	    	})
	    }
	    async handleGetDetail(id:any) {
	    	if(this.initData.details[id]) {
	    		return this.initData.details[id];
	    	}
	    	await Ajax.get('/api/services/app/EducationTrain/GetDetailAsync', {params: {id: id}}).then((res:any)=>{
	    		this.initData.details[id] = res.data.result;
            })
	    	return this.initData.details[id] || {};
	    }
	    // 查看详情
	    handleLookDetail(id:any) {
	    	this.handleGetDetail(id).then((res:any) => {
	    		this.initData.detailForm = res;
	    		this.initData.showDetailModal = true;
	    	})
	    }
        mounted() {
        	this.init();
        }
    }
